module.exports = __webpack_public_path__ + "img/map_berkeley_bg_1.df16f8c6.jpg";